import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import menu_icon from "../Images/menu-icon.svg";
import Footer from "../Components/Footer";
import Menu from "../Components/Menu";
import InviteBanner from "../Images/pointsImg.png";
import alllogo from "../Images/back.png";
import pointslogo from "../Images/points.png";

import "../Css/newcss.css";
import { getreferalPoints } from "../Data/data";
import axios from "axios";

export const ReferalPoints = () => {
    const navigate=useNavigate()
  const [points, setPoints] = useState(0);
  const number = localStorage.getItem("ani");

  const getrefrealpoints = async () => {
    try {
      const response = await axios.get(getreferalPoints, {
        params: { ani: number },
      });

      if (response.data && response.data.points !== undefined) {
        setPoints(response.data.points);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.points !== undefined
      ) {
        setPoints(error.response.data.points);
      } else {
        console.error("Error fetching referral points:", error);
      }
    }
  };

  useEffect(() => {
    getrefrealpoints();
  }, []);

  return (
    <>
      <Menu
        one="active"
        two="inactive"
        three="inactive"
        four="inactive"
        five="inactive"
        six="inactive"
      />

      <div className="container bg-color-yellow main-home">
        {/* Header */}
        <div className="cus-header">
          <div className="col-md-6 col-xs-6">
            <div className="page-icon">
              <img src={alllogo} alt="alllogo" />
              <Link to={"/homepage"}>My Referral Points</Link>
            </div>
          </div>
          <div className="col-md-6 col-xs-6">
            <span
              className="cus-menu navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              aria-expanded="false"
            >
              <img alt="logo" src={menu_icon} />
              <span className="text-unselect cursor-pointer">menu</span>
            </span>
          </div>
        </div>

        {/* Banner Image */}
        <div className="banner-image-container">
          <img src={InviteBanner} alt="Invite Banner" className="banner-image" />

          <div className="banner-content" onClick={()=>navigate('/refer')}>
            <div className="text-content">
              <p className="txt-heading">Invite a Friend & Earn Rewards</p>
              <p>
                Earn points every time your referral code is used — redeem for
                airtime, cash & more.
              </p>
              <p className="cta-text">Share Your Code Now &gt;</p>
            </div>
            <img src={pointslogo} alt="Gift Icon" className="icon-image" />
          </div>
        </div>

        {/* Referral Summary */}
        <div className="referral-summary-section">
          <div className="points-box">
            <div className="points-text">
              <p>My Points</p>
              <h2>
                <span className="txt-points">{points}</span>
                <span>Total</span>
              </h2>
            </div>
            <div className="points-icon">
              <img src={pointslogo} alt="gift" />
            </div>
          </div>

          <div className="referral-buttons">
            <button className="ref-btn" onClick={()=>navigate('/refer')}>Invite More</button>
            <button className="ref-btn" onClick={()=>navigate('/homepage')}>Play Now</button>
          </div>

          <div className="summary-title">Summary</div>

          <div className="summary-item">
            <div className="summary-count yellow-bg">27</div>
            <div className="summary-text">
              <p className="summary-label">Invites Sent</p>
              <p className="summary-desc">Referral Invites Sent</p>
            </div>
            <div className="summary-points">
              <span className="summry-count">+2</span>
              <br />
              <span>Referral points</span>
            </div>
          </div>

          <div className="summary-item">
            <div className="summary-count yellow-bg">12</div>
            <div className="summary-text">
              <p className="summary-label">Subscribed Invites</p>
              <p className="summary-desc">Referral Invites Subscribes</p>
            </div>
            <div className="summary-points">
              <span className="summry-count">+2</span>
              <br />
              <span>Referral points</span>
            </div>
          </div>
        </div>

        {/* How it works section */}
        <div className="refer-section px-4 py-6">
          <div className="how-it-works mt-5">
            <p className="how-title">How does it work?</p>
            <ul className="how-list">
              <li>Share your unique referral code with friends.</li>
              <li>
                When they sign up and play Bigcash Games MTN, you earn points
                that can be redeemed for airtime, cash, and other exciting
                rewards.
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Section */}
        <div className="btn">
          <div className="button-container" onClick={()=>navigate('/homepage')}>
            <p className="button-text">Continue Playing</p>
          </div>
          <hr className="divider-line" />
          <Footer
            one="active"
            two="inactive"
            three="inactive"
            four="inactive"
          />
        </div>
      </div>
    </>
  );
};




// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import ReactGA from "react-ga";

// import menu_icon from "../Images/menu-icon.svg";

// import Footer from "../Components/Footer";
// import Menu from "../Components/Menu";
// import { sendServicesDataApi } from "../Data/data";
// import Get from "../Api/Get";
// import Loader from "../Components/Loader";
// import onestar from "../NewImages/1star.png";
// import play from "../NewImages/play.png";

// import alllogo from "../Images/back.png";
// import InviteBanner from "../Images/pointsImg.png"
// import remote from "../NewImages/remo4.png";
// import "../Css/newcss.css";
// import pointslogo from '../Images/points.png'
// import { FaCopy, FaWhatsapp, FaFacebook, FaEnvelope, FaGoogle, FaFacebookMessenger } from "react-icons/fa";
// import { MdOutlineMail } from "react-icons/md";
// import { RiWhatsappFill } from "react-icons/ri";
// import { FcGoogle } from "react-icons/fc";





// export const ReferalPoints = () => {

//     return (
//         <>
//             {/* <Loader value={loader} /> */}
//             <Menu
//                 one="active"
//                 two="inactive"
//                 three="inactive"
//                 four="inactive"
//                 five="inactive"
//                 six="inactive"
//             />
//             <div className="container bg-color-yellow main-home">
//                 <div className="cus-header">
//                     <div className="col-md-6 col-xs-6">
//                         <div className="page-icon">
//                             <img src={alllogo} alt="allogo" />
//                             <Link to={"/homepage"}>My Referral Points </Link>
//                         </div>
//                     </div>
//                     <div className="col-md-6 col-xs-6">
//                         <span
//                             className="cus-menu navbar-toggle collapsed"
//                             data-toggle="collapse"
//                             data-target="#bs-example-navbar-collapse-1"
//                             aria-expanded="false"
//                         >
//                             <img alt="logo" src={menu_icon} />
//                             <span className="text-unselect cursor-pointer">menu</span>
//                         </span>
//                     </div>

//                 </div>


//                 <div className="banner-image">
//   <img src={InviteBanner} alt="Invite Banner" />
// </div>




//                 <div className="referral-summary-section">
//                     <div className="points-box">
//                         <div className="points-text">
//                             <p>My Points</p>
//                             <h2 >
//                                 <span className="txt-points">
//                                     2,300
//                                 </span>
//                                 <span>Total</span></h2>
//                         </div>
//                         <div className="points-icon">
//                             <img src={pointslogo} alt="gift" />
//                         </div>
//                     </div>

//                     <div className="referral-buttons">
//                         <button className="ref-btn">Redeem</button>
//                         <button className="ref-btn">Invite More</button>
//                         <button className="ref-btn">Play Now</button>
//                     </div>

//                     <div className="summary-title">Summary</div>

//                     <div className="summary-item">
//                         <div className="summary-count yellow-bg">27</div>
//                         <div className="summary-text">
//                             <p className="summary-label">Invites Sent</p>
//                             <p className="summary-desc">Referral Invites Sent</p>
//                         </div>
//                         <div className="summary-points">
//                              <span className="summry-count">
//                                 +2
//                             </span>
//                             <br /><span>Referral points</span></div>
//                     </div>

//                     <div className="summary-item">
//                         <div className="summary-count yellow-bg">12</div>
//                         <div className="summary-text">
//                             <p className="summary-label">Subscribed Invites</p>
//                             <p className="summary-desc">Referral Invites Subscribes</p>
//                         </div>
//                         <div className="summary-points">
//                             <span className="summry-count">
//                                 +2
//                             </span>
//                             <br /><span>Referral points</span></div>
//                     </div>
//                 </div>

//                 <div className="refer-section px-4 py-6">




//                     <div className="how-it-works mt-5">
//                         <p className="how-title">How does it work?</p>
//                         <ul className="how-list">
//                             <li>Share your unique referral code with friends.</li>
//                             <li>
//                                 When they sign up and play Bigcash Games MTN, you earn points that can be redeemed
//                                 for airtime, cash, and other execiting rewards.
//                             </li>
//                         </ul>
//                     </div>

//                     {/* <button className="referral-btn">My Referral Points</button> */}
//                 </div>
//                 <div className="btn">
//                     <div className="button-container">
//                         <p className="button-text">Continue Playing</p>

//                     </div>
//                      <hr className="divider-line" />
//                     <Footer
//                         one="active"
//                         two="inactive"
//                         three="inactive"
//                         four="inactive"
//                     />

//                 </div>
//             </div>





//         </>
//     );
// };




// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// import menu_icon from "../Images/menu-icon.svg";
// import Footer from "../Components/Footer";
// import Menu from "../Components/Menu";
// import InviteBanner from "../Images/pointsImg.png";
// import alllogo from "../Images/back.png";
// import pointslogo from "../Images/points.png";

// import "../Css/newcss.css";
// import { getreferalPoints } from "../Data/data";
// import axios from "axios";

// export const ReferalPoints = () => {
//     const [points,setPoints]=useState('')
//     const number =localStorage.getItem("ani")

//     const getrefrealpoints = async () => {
//   try {
//     const response = await axios.get(getreferalPoints, {
//       params: {
//         ani: number,
//       },
//     });
//     console.log(response.data, "==response===");
//   } catch (error) {
//     console.error("Error fetching referral points:", error);
//   }
// };


//     useEffect(()=>{
//         getrefrealpoints()
//     },[])
//     return (
//         <>
//             <Menu
//                 one="active"
//                 two="inactive"
//                 three="inactive"
//                 four="inactive"
//                 five="inactive"
//                 six="inactive"
//             />

//             <div className="container bg-color-yellow main-home">
//                 {/* Header */}
//                 <div className="cus-header">
//                     <div className="col-md-6 col-xs-6">
//                         <div className="page-icon">
//                             <img src={alllogo} alt="allogo" />
//                             <Link to={"/homepage"}>My Referral Points</Link>
//                         </div>
//                     </div>
//                     <div className="col-md-6 col-xs-6">
//                         <span
//                             className="cus-menu navbar-toggle collapsed"
//                             data-toggle="collapse"
//                             data-target="#bs-example-navbar-collapse-1"
//                             aria-expanded="false"
//                         >
//                             <img alt="logo" src={menu_icon} />
//                             <span className="text-unselect cursor-pointer">menu</span>
//                         </span>
//                     </div>
//                 </div>

//                 {/* Banner Image */}
//                 {/* <div className="banner-image-container">
//     <img src={InviteBanner} alt="Invite Banner" className="banner-image" />
// </div> */}

//      <div className="banner-image-container">
//   <img src={InviteBanner} alt="Invite Banner" className="banner-image" />

//   <div className="banner-content">
//     <div className="text-content">
//       <p className="txt-heading">Invite a Friend & Earn Rewards</p>
//       <p>Earn points every time your referral code is used — redeem for airtime, cash & more.</p>
//       <p className="cta-text">Share Your Code Now &gt;</p>
//     </div>
//     <img src={pointslogo} alt="Gift Icon" className="icon-image" />
//   </div>
// </div>






//                 {/* Referral Summary */}
//                 <div className="referral-summary-section">
//                     <div className="points-box">
//                         <div className="points-text">
//                             <p>My Points</p>
//                             <h2>
//                                 <span className="txt-points">2,300</span>
//                                 <span>Total</span>
//                             </h2>
//                         </div>
//                         <div className="points-icon">
//                             <img src={pointslogo} alt="gift" />
//                         </div>
//                     </div>

//                     <div className="referral-buttons">
//                         {/* <button className="ref-btn">Redeem</button> */}
//                         <button className="ref-btn">Invite More</button>
//                         <button className="ref-btn">Play Now</button>
//                     </div>

//                     <div className="summary-title">Summary</div>

//                     <div className="summary-item">
//                         <div className="summary-count yellow-bg">27</div>
//                         <div className="summary-text">
//                             <p className="summary-label">Invites Sent</p>
//                             <p className="summary-desc">Referral Invites Sent</p>
//                         </div>
//                         <div className="summary-points">
//                             <span className="summry-count">+2</span>
//                             <br />
//                             <span>Referral points</span>
//                         </div>
//                     </div>

//                     <div className="summary-item">
//                         <div className="summary-count yellow-bg">12</div>
//                         <div className="summary-text">
//                             <p className="summary-label">Subscribed Invites</p>
//                             <p className="summary-desc">Referral Invites Subscribes</p>
//                         </div>
//                         <div className="summary-points">
//                             <span className="summry-count">+2</span>
//                             <br />
//                             <span>Referral points</span>
//                         </div>
//                     </div>
//                 </div>

//                 {/* How it works section */}
//                 <div className="refer-section px-4 py-6">
//                     <div className="how-it-works mt-5">
//                         <p className="how-title">How does it work?</p>
//                         <ul className="how-list">
//                             <li>Share your unique referral code with friends.</li>
//                             <li>
//                                 When they sign up and play Bigcash Games MTN, you earn points
//                                 that can be redeemed for airtime, cash, and other exciting
//                                 rewards.
//                             </li>
//                         </ul>
//                     </div>
//                 </div>

//                 {/* Footer Section */}
//                 <div className="btn">
//                     <div className="button-container">
//                         <p className="button-text">Continue Playing</p>
//                     </div>
//                     <hr className="divider-line" />
//                     <Footer
//                         one="active"
//                         two="inactive"
//                         three="inactive"
//                         four="inactive"
//                     />
//                 </div>
//             </div>
//         </>
//     );
// };
